export default __webpack_public_path__ + "static/media/moveIcon.239e59f5.svg";